import { KeyCloakConfig } from "../config";

interface IAuth {
    id: string,
    refreshToken: string,
}

class authorizationService {

    refresh(data: IAuth): Promise<any> {
        let keycloakData = {
            'refresh_token': data.refreshToken,
            ...KeyCloakConfig.refresh
        }

        let params = new URLSearchParams(keycloakData),
            body = params.toString();

        return fetch(`${process.env.REACT_APP_KEYCLOAK_AUTH_URL}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body
        })
    }

}

export default new authorizationService();